import { buildIdempotencyKey as buildIdempotencyKeyShared, DEFAULT_AGENT_EXECUTION_TIMEOUT_MS, DEFAULT_IDEMPOTENCY_WINDOW_MS, shouldDedupeWithinWindow as shouldDedupeWithinWindowShared, } from "@wakeloop/agent-runtime";
const DEDUPE_WINDOW_MS = DEFAULT_IDEMPOTENCY_WINDOW_MS;
export const buildIdempotencyKey = buildIdempotencyKeyShared;
const REQUIRED_OBSERVABILITY_FIELDS = [
    "ts",
    "level",
    "component",
    "code",
    "message",
    "runId",
    "bindingKey",
    "taskId",
    "eventId",
    "errorType",
];
export const shouldDedupeWithinWindow = (input) => {
    return shouldDedupeWithinWindowShared({
        firstSeenAtMs: input.firstSeenAtMs,
        nowMs: input.nowMs,
        ...(typeof input.windowMs === "number" ? { windowMs: input.windowMs } : {}),
    });
};
export const shouldBypassDedupeForDeliveryRecoveryReason = (reason) => {
    return reason === "connection_replaced" || reason === "route_lost";
};
export const assertSameBindingFifo = (dispatches) => {
    const latestByBinding = new Map();
    for (const dispatch of dispatches) {
        const latest = latestByBinding.get(dispatch.bindingKey);
        if (latest !== undefined && dispatch.sequence < latest) {
            return false;
        }
        latestByBinding.set(dispatch.bindingKey, dispatch.sequence);
    }
    return true;
};
export const hasRequiredObservabilityFields = (entry) => {
    for (const field of REQUIRED_OBSERVABILITY_FIELDS) {
        const value = entry[field];
        if (typeof value !== "string" || value.length === 0) {
            return false;
        }
    }
    return true;
};
export const DATA_PLANE_DEFAULTS = {
    dedupeWindowMs: DEDUPE_WINDOW_MS,
    globalConcurrency: 4,
    perBindingQueue: 32,
    timeoutMs: DEFAULT_AGENT_EXECUTION_TIMEOUT_MS,
    backoffMs: [1000, 2000, 5000, 10_000, 30_000],
};
